import ProfileLayout from '@/components/landing/account/ProfileLayout';
import PurchaseHistoryComponent from '@/components/purchase-history';
import React from 'react';

const PurchaseHistory = () => {
  return (
    <ProfileLayout>
      <PurchaseHistoryComponent />
    </ProfileLayout>
  );
};
export default PurchaseHistory;
